import { SpecialBetGroups } from '../types/bet';
import { SportIds } from '../types/sports';

import { BetEntity, BetState } from './entities/bets';
import { MatchEntity, MatchState } from './entities/matches';

class BetGroup {
  static getSpecial = (
    match: MatchState,
    bet: BetState,
    matchBets: Array<BetState>,
    isMultichoice: boolean = false,
  ) => {
    let specialBetGroup = null;

    if (match && bet) {
      // Special cases soccer
      if (match.sportId === SportIds.SOCCER) {
        if (BetEntity.isSoccerAsianTextHandicap(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_ASIANTEXT_HANDICAP;
        } else if (BetEntity.isSoccerScorerGoalType(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_GOAL_TYPE;
        } else if (BetEntity.isSoccerCompetitorGoalType(bet, match, matchBets)) {
          specialBetGroup = SpecialBetGroups.SOCCER_COMPETITOR_GOAL_TYPE;
        } else if (BetEntity.isDuoScorer(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_DUO_SCORERS;
        } else if (BetEntity.isTrioScorer(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_TRIO_SCORERS;
        } else if (BetEntity.isSoccerScorerPeriod10Minutes(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORER_PERIOD_10MINUTES;
        } else if (BetEntity.isSoccerScorerPeriod15Minutes(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORER_PERIOD_15MINUTES;
        } else if (BetEntity.isSoccerScorerPeriodHalfTime(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORER_PERIOD_HALF_TIME;
        } else if (BetEntity.isSoccerMultiScorerHalfTime1(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_MULTI_SCORER_1_HT;
        } else if (BetEntity.isSoccerMultiScorerHalfTime2(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_MULTI_SCORER_2_HT;
        } else if (BetEntity.isSoccerScorerVsCompetitor(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORER_VS_COMPETITOR;
        } else if (BetEntity.isSoccerScorerVsScorer(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORER_VS_SCORER;
        } else if (BetEntity.isSoccerScorerAndTeamWins(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_AND_TEAM_WINS;
        } else if (BetEntity.isSoccerNextScorerOvertime(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_NEXT_SCORERS_OVERTIME;
        } else if (BetEntity.isSoccerScorerOvertime(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_OVERTIME;
        } else if (BetEntity.isSoccerOver2ScorerOvertime(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_OVER_2_SCORERS_OVERTIME;
        } else if (BetEntity.isSoccerScorerOvertimeFirstHaltTime(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_OVERTIME_1_HT;
        } else if (BetEntity.isSoccerScorerOvertimeSecondHaltTime(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_OVERTIME_2_HT;
        } else if (BetEntity.isSoccerMultiscorersPrematch(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_MULTI_SCORERS_PREMATCH;
        } else if (BetEntity.isSoccerNumberCard(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_NUMBER_CARD_PLAYER;
        } else if (BetEntity.isSoccerPlayerPropAssists(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_PLAYER_PROPS_ASSISTS;
        } else if (BetEntity.isSoccerPlayerPropShots(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_PLAYER_PROPS_SHOTS;
        } else if (BetEntity.isSoccerPlayerPropShotsOnGoal(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_PLAYER_PROPS_SHOTS_ON_GOAL;
        } else if (BetEntity.isSoccerPlayerPropPasses(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_PLAYER_PROPS_PASSES;
        } else if (BetEntity.isSoccerPlayerPropTackles(bet)) {
          specialBetGroup = SpecialBetGroups.SOCCER_PLAYER_PROPS_TACKLES;
        } else if (BetEntity.isSoccerDecisivePlayer(bet, matchBets)) {
          specialBetGroup = SpecialBetGroups.SOCCER_DECISIVE_PLAYERS;
        } else if (MatchEntity.isLive(match)) {
          const isSoccerScorersLive = BetEntity.isSoccerScorersLive(bet, match, matchBets);
          const isSoccerScorersLiveWithoutLastScorer = BetEntity.isSoccerScorersLiveWithoutLastScorer(
            bet,
            match,
            matchBets,
          );
          const isSoccerMultiScorers2or3Live = BetEntity.isSoccerMultiScorers2or3Live(bet);

          if (
            isMultichoice &&
            (isSoccerScorersLive || isSoccerScorersLiveWithoutLastScorer || isSoccerMultiScorers2or3Live)
          ) {
            specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_SOCCER_SCORERS;
          } else {
            if (isSoccerScorersLive) {
              specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_LIVE;
            } else if (isSoccerScorersLiveWithoutLastScorer) {
              specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_LIVE_WITHOUT_LAST_SCORER;
            } else if (isSoccerMultiScorers2or3Live) {
              specialBetGroup = SpecialBetGroups.SOCCER_MULTI_SCORERS_LIVE;
            }
          }
        } else if (MatchEntity.isPrematch(match) || MatchEntity.isEnded(match)) {
          if (BetEntity.isSoccerScorersPrematch(bet)) {
            if (isMultichoice) {
              specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_SOCCER_SCORERS;
            } else {
              specialBetGroup = SpecialBetGroups.SOCCER_SCORERS_PREMATCH;
            }
          }
        }
      }

      if (match.sportId === SportIds.FOOTBALL) {
        if (BetEntity.isFootballScorers(bet)) {
          if (isMultichoice) {
            specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_FOOTBALL_SCORERS;
          } else {
            specialBetGroup = SpecialBetGroups.FOOTBALL_SCORERS;
          }
        }
      }

      if (match.sportId === SportIds.BASKETBALL) {
        if (BetEntity.isBasketballPointPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_POINT_PLAYER;
        }
        if (BetEntity.isBasketballPassPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PASS_PLAYER;
        }
        if (BetEntity.isBasketballReboundPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_REBOUND_PLAYER;
        }
        if (BetEntity.isBasketball3PointPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_3POINT_PLAYER;
        }
        if (BetEntity.isBasketballDoubleChancePlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_DOUBLE_CHANCE_PLAYER;
        }
        if (BetEntity.isBasketballSumPoint2Players(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_SUM_POINT_2PLAYERS;
        }
        if (BetEntity.isBasketballSumPoint3Players(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_SUM_POINT_3PLAYERS;
        }
        if (BetEntity.isBasketballPointPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_POINT_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballPassPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PASS_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballReboundPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_REBOUND_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketball3PointPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_3POINTS_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballPointReboundPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_POINT_REBOUND_ASSIST_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballPointPassPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_POINT_PASS_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballPassReboundPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PASS_REBOUND_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballPointRebondPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_POINT_REBOUND_PLAYER_OVER_UNDER;
        }
        if (BetEntity.isBasketballInterceptPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PLAYER_INTERCEPT_OVER_UNDER;
        }
        if (BetEntity.isBasketballBlockPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PLAYER_BLOCK_OVER_UNDER;
        }
        if (BetEntity.isBasketballLostBallPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PLAYER_LOST_BALL_OVER_UNDER;
        }
        if (BetEntity.isBasketballTotalInterceptBlockPlayerOverUnder(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK_OVER_UNDER;
        }
        if (BetEntity.isBasketballTotalPointsReboundAssistPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND_ASSIST;
        }
        if (BetEntity.isBasketballTotalPointsAssistPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_ASSIST;
        }
        if (BetEntity.isBasketballTotalAssistReboundPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_ASSIST_REBOUND;
        }
        if (BetEntity.isBasketballTotalPointsReboundPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND;
        }
        if (BetEntity.isBasketballInterceptPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PLAYER_INTERCEPT;
        }
        if (BetEntity.isBasketballBlockPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PLAYER_BLOCK;
        }
        if (BetEntity.isBasketballLostBallPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_PLAYER_LOST_BALL;
        }
        if (BetEntity.isBasketballTotalInterceptBlockPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK;
        }
        if (BetEntity.isBasketballNumberOfPointsHeadToHeadPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_NUMBER_OF_POINTS_HEAD_TO_HEAD;
        }
        if (BetEntity.isBasketballNumberOfAssistsHeadToHeadPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_NUMBER_OF_ASSISTS_HEAD_TO_HEAD;
        }
        if (BetEntity.isBasketballNumberOfReboundsHeadToHeadPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.BASKETBALL_NUMBER_OF_REBOUNDS_HEAD_TO_HEAD;
        }
      }

      if (match.sportId === SportIds.RUGBY) {
        if (BetEntity.isRugbyScorers(bet, matchBets)) {
          if (isMultichoice) {
            specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_RUGBY_SCORERS;
          } else {
            specialBetGroup = SpecialBetGroups.RUGBY_SCORERS;
          }
        } else if (BetEntity.isDuoScorer(bet)) {
          specialBetGroup = SpecialBetGroups.RUGBY_DUO_SCORERS;
        } else if (BetEntity.isTrioScorer(bet)) {
          specialBetGroup = SpecialBetGroups.RUGBY_TRIO_SCORERS;
        } else if (BetEntity.isRugbyScorersLive(bet, matchBets)) {
          if (isMultichoice) {
            specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_RUGBY_SCORERS;
          } else {
            specialBetGroup = SpecialBetGroups.RUGBY_SCORERS_LIVE;
          }
        }
      }

      if (match.sportId === SportIds.RUGBY_LEAGUE) {
        if (BetEntity.isRugbyLeagueScorers(bet, matchBets)) {
          if (isMultichoice) {
            specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_RUGBY_LEAGUE_SCORERS;
          } else {
            specialBetGroup = SpecialBetGroups.RUGBY_LEAGUE_SCORERS;
          }
        } else if (BetEntity.isDuoScorer(bet)) {
          specialBetGroup = SpecialBetGroups.RUGBY_DUO_SCORERS;
        } else if (BetEntity.isTrioScorer(bet)) {
          specialBetGroup = SpecialBetGroups.RUGBY_TRIO_SCORERS;
        } else if (BetEntity.isRugbyLeagueScorersLive(bet, matchBets)) {
          specialBetGroup = SpecialBetGroups.RUGBY_LEAGUE_SCORERS_LIVE;
        }
      }

      if (match.sportId === SportIds.RUGBY_7S) {
        if (BetEntity.isRugby7sScorers(bet, matchBets)) {
          specialBetGroup = SpecialBetGroups.RUGBY_7S_SCORERS;
        }
        if (BetEntity.isRugby7sScorersLive(bet, matchBets)) {
          specialBetGroup = SpecialBetGroups.RUGBY_7S_SCORERS_LIVE;
        }
      }

      if (match.sportId === SportIds.ICEHOCKEY) {
        if (BetEntity.isDuoScorer(bet)) {
          specialBetGroup = SpecialBetGroups.ICE_HOCKEY_DUO_SCORERS;
        }
        if (BetEntity.isTrioScorer(bet)) {
          specialBetGroup = SpecialBetGroups.ICE_HOCKEY_TRIO_SCORERS;
        }
        if (BetEntity.isIceHockeyScorerPeriod(bet)) {
          specialBetGroup = SpecialBetGroups.ICE_HOCKEY_SCORER_PERIOD;
        }
        if (MatchEntity.isLive(match)) {
          if (BetEntity.isIceHockeyScorerLive(bet, matchBets)) {
            specialBetGroup = SpecialBetGroups.ICE_HOCKEY_SCORER_LIVE;
          }
          if (BetEntity.isIceHockeyMultiScorer(bet)) {
            specialBetGroup = SpecialBetGroups.ICE_HOCKEY_MULTI_SCORER_LIVE;
          }
        } else if (MatchEntity.isPrematch(match)) {
          if (BetEntity.isIceHockeyScorers(bet)) {
            if (isMultichoice) {
              specialBetGroup = SpecialBetGroups.MULTICHOICE_MM_ICE_HOCKEY_SCORERS;
            } else {
              specialBetGroup = SpecialBetGroups.ICE_HOCKEY_SCORERS;
            }
          }
        }
      }

      if (match.sportId === SportIds.HANDBALL) {
        if (BetEntity.isHandballScorersPlayer(bet)) {
          specialBetGroup = SpecialBetGroups.HANDBALL_SCORERS_PLAYER;
        }
      }
    }

    return specialBetGroup;
  };
}

export default BetGroup;
